<template>
  <div class="home">
    开元寺 1
  </div>

</template>

<script>
export default {
  data() {
    return {};
  },

  methods: {},
};
</script>


<style scoped>
</style>
